import { resolveHairTenantPortal } from '../config/hairApp';

import {
  getApiBaseUrl as getEnterpriseApiBaseUrl,
  SALON_API_PREFIX as ENTERPRISE_SALON_API_PREFIX,
} from '../../../../enterprise/salon/utils/apiConfig';
import { fetchWithRetry as enterpriseFetchWithRetry } from '../../../../enterprise/salon/utils/fetchWithRetry';
import { TIMEOUT_MS as ENTERPRISE_TIMEOUT_MS } from '../../../../enterprise/salon/utils/salonResilience';
import {
  franchiseAuthHeaders as enterpriseFranchiseAuthHeaders,
  resolveFranchiseScopeIds as enterpriseResolveFranchiseScopeIds,
} from '../../../../enterprise/shared/franchiseFlowAuth';

import {
  getApiBaseUrl as getNaturalsApiBaseUrl,
  SALON_API_PREFIX as NATURALS_SALON_API_PREFIX,
} from '../../../../naturals/salon/utils/apiConfig';
import { fetchWithRetry as naturalsFetchWithRetry } from '../../../../naturals/salon/utils/fetchWithRetry';
import { TIMEOUT_MS as NATURALS_TIMEOUT_MS } from '../../../../naturals/salon/utils/salonResilience';
import {
  franchiseAuthHeaders as naturalsFranchiseAuthHeaders,
  resolveFranchiseScopeIds as naturalsResolveFranchiseScopeIds,
} from '../../../../naturals/shared/franchiseFlowAuth';

import {
  getApiBaseUrl as getNyafazEpApiBaseUrl,
  SALON_API_PREFIX as NYAFAZ_EP_SALON_API_PREFIX,
} from '../../../../nyafaz-ep/salon/utils/apiConfig';
import { fetchWithRetry as nyafazEpFetchWithRetry } from '../../../../nyafaz-ep/salon/utils/fetchWithRetry';
import { TIMEOUT_MS as NYAFAZ_EP_TIMEOUT_MS } from '../../../../nyafaz-ep/salon/utils/salonResilience';
import {
  franchiseAuthHeaders as nyafazEpFranchiseAuthHeaders,
  resolveFranchiseScopeIds as nyafazEpResolveFranchiseScopeIds,
} from '../../../../nyafaz-ep/shared/franchiseFlowAuth';

export function resolveHairSalonApiDeps() {
  const portal = resolveHairTenantPortal();
  if (portal === 'nyafaz_ep') {
    return {
      getApiBaseUrl: getNyafazEpApiBaseUrl,
      SALON_API_PREFIX: NYAFAZ_EP_SALON_API_PREFIX,
      fetchWithRetry: nyafazEpFetchWithRetry,
      TIMEOUT_MS: NYAFAZ_EP_TIMEOUT_MS,
      franchiseAuthHeaders: nyafazEpFranchiseAuthHeaders,
      resolveFranchiseScopeIds: nyafazEpResolveFranchiseScopeIds,
    };
  }
  if (portal === 'naturals') {
    return {
      getApiBaseUrl: getNaturalsApiBaseUrl,
      SALON_API_PREFIX: NATURALS_SALON_API_PREFIX,
      fetchWithRetry: naturalsFetchWithRetry,
      TIMEOUT_MS: NATURALS_TIMEOUT_MS,
      franchiseAuthHeaders: naturalsFranchiseAuthHeaders,
      resolveFranchiseScopeIds: naturalsResolveFranchiseScopeIds,
    };
  }
  return {
    getApiBaseUrl: getEnterpriseApiBaseUrl,
    SALON_API_PREFIX: ENTERPRISE_SALON_API_PREFIX,
    fetchWithRetry: enterpriseFetchWithRetry,
    TIMEOUT_MS: ENTERPRISE_TIMEOUT_MS,
    franchiseAuthHeaders: enterpriseFranchiseAuthHeaders,
    resolveFranchiseScopeIds: enterpriseResolveFranchiseScopeIds,
  };
}

export function getHairSalonApiBaseUrl() {
  return (resolveHairSalonApiDeps().getApiBaseUrl() || '').replace(/\/$/, '');
}
